import { useCallback, useEffect, useMemo, useState } from 'react'
import { Platform } from 'react-native'
import fb from '../../utils/service/fb'

export default function useRecaptcha(id = 'recaptcha') {
  const [elementId] = useState(id)
  const [verifier, setRecaptchaVerifier] =
    useState<fb.auth.RecaptchaVerifier | null>(null)

  const cleanVerifier = useCallback(() => {
    console.log(`cleaned ${elementId}`)
    if (verifier) {
      try {
        verifier.clear()
      } catch (e) {
        console.log(e)
      } finally {
        setRecaptchaVerifier(null)
      }
    }
    if (Platform.OS === 'web') {
      const div = document.getElementById(elementId)
      div && div.parentNode?.removeChild(div)
    }
  }, [elementId, verifier])

  const createVerifier = useCallback(() => {
    cleanVerifier()
    console.log(`recaptcha created ${elementId}`)
    if (Platform.OS === 'web') {
      const div = document.createElement('div')
      div.id = elementId
      document.body.appendChild(div)
      const recaptchaVerifier = new fb.auth.RecaptchaVerifier(elementId, {
        size: 'invisible',
      })
      setRecaptchaVerifier(recaptchaVerifier)
    }
  }, [cleanVerifier, elementId])

  useEffect(() => {
    if (elementId !== 'signin') {
      return cleanVerifier
    }
    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return useMemo(
    () => ({
      verifier,
      createVerifier,
      cleanVerifier,
    }),
    [verifier, createVerifier, cleanVerifier],
  )
}
